import styled from "styled-components";
import { Modal } from "antd";

export const ModalWrapper = styled(Modal)`
  .ant-modal {
    top: 400px;
  }

  .ant-modal-content {
    border-radius: 8px;
  }

  .ant-modal-body {
    padding-top: 24px;

    > p {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      margin-bottom: 0;
      font-size: 16px;
      font-weight: 600;
    }
  }

  .ant-modal-header {
    border-radius: 8px 8px 0 0;
  }
  .ant-modal-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    padding: 0;
    padding: 10px;
    border-radius: 8px;

    button {
      border-radius: 8px;
      border: 0;
      cursor: pointer;
      width: 100px;
      padding: 6px;
      color: #ffffff;
      text-align: center;
      font-size: 14px;

      &.btn-cancel {
        background: #ffffff;
        border: 1px solid #174a83;
        color: #174a83;
        min-width: 120px;
      }
    }
  }

  .wrap-list-icon-app {
    display: flex;
    flex-wrap: wrap;

    .wrap-icon-app {
      width: 72px;
      height: 72px;
      padding: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 8px;
      cursor: pointer;

      &.selected {
        background-color: #e7e8ea;
      }

      img {
        width: 40px;
        height: 40px;
      }
    }
  }
`;
